module.exports = __webpack_public_path__ + "610daee12343afb626ff816ae4fb88e7.png";